import { render } from "./EquipoProfesional.vue?vue&type=template&id=3d394580"
const script = {}
script.render = render

export default script